import React from "react";

const FilterIcon = ({ style, color = "#4548C4" }) => <svg width="18" height="18" style={{ ...style, minWidth: "18px", minHeight: "18px" }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.5 9H13.5M2.25 4.5H15.75M6.75 13.5H11.25" stroke={color} strokeWidth="1.6" strokeLinecap="round"
    strokeLinejoin="round" />
</svg>;

export default FilterIcon;
